import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ServiceInterfaceSettingsResult } from "@/interfaces/service-interface.interface";
import serviceInterfaceService from "@/services/service-interface.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export interface Props {
  serviceInterfaceId: number | null;
  enabled: boolean;
}

type SwrParams = [string, number];

export type Return = RequestsBaseReturn<ServiceInterfaceSettingsResult | null>;

const useGetServiceInterfaceSettings = ({ serviceInterfaceId, enabled }: Props): Return => {
  const fetcher = useSWR<ServiceInterfaceSettingsResult, Error, SwrParams | null>(
    enabled && serviceInterfaceId != null
      ? [SWR_KEYS.getServiceInterfaceSettings, serviceInterfaceId]
      : null,
    ([, id]) => serviceInterfaceService.getSettings(id),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetServiceInterfaceSettings;
